import React, { useState, useEffect } from 'react';
import {Box,Typography,Button,TextField,InputAdornment,Paper,Table,TableBody,TableCell,TableContainer,TableHead,TableRow,IconButton,
  Dialog,DialogTitle,DialogContent,DialogActions,Grid,FormControl,Select,InputLabel,MenuItem,TablePagination,Snackbar,Alert,Tooltip,
  useTheme,
  useMediaQuery} from '@mui/material';
import {Search as SearchIcon,Add as AddIcon,EditRounded as EditIcon,DeleteRounded as DeleteIcon,WhatsApp as WhatsAppIcon} from '@mui/icons-material';
import { fetchAllServicePayments } from '../api';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import SearchInput from '../customcomponents/CustomSearchInput';
import SelectInput from '../customcomponents/CustomSelectInput';
import PillComponent from '../customcomponents/CustomPillComponent';

function PaymentReportPage() {
  
  const theme = useTheme();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState({ phone: '', email: '' });
  const [payments, setPayments] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const isSmallScreen = useMediaQuery('(max-width:800px)');

  // const filteredPays = payments.filter(pay => {
  //   if (statusFilter === 'paid' && pay.TASP_IsPaid !== true) return false;
  //   if (statusFilter === 'unpaid' && pay.TASP_IsPaid == true) return false  ;
  //   return (
  //     (pay.userName && pay.userName.toLowerCase().includes(searchQuery.toLowerCase())) ||
  //     (pay.mobileNumber && pay.mobileNumber.includes(searchQuery)) ||
  //     (pay.email && pay.email.toLowerCase().includes(searchQuery.toLowerCase()))
  //   );
  // });

  // const paginatedPays = payments.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const filteredPays = payments.filter(pay => {
    if (statusFilter === 'paid' ) {
      return (
        pay.TASP_IsPaid == true
      )
    } else if (statusFilter === 'unpaid' && pay.TASP_IsPaid == true ) {
      return (
        pay.TASP_IsPaid == false
      )
    }
    else {
      return (
        (pay.userName && pay.userName.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (pay.mobileNumber && pay.mobileNumber.includes(searchQuery)) ||
        (pay.email && pay.email.toLowerCase().includes(searchQuery.toLowerCase()))
      );
    }
  });

  const paginatedPays = payments.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).filter(pay => {
    if (statusFilter === 'paid' ) {
      return (
        pay.TASP_IsPaid == true
      )
    } else if (statusFilter === 'unpaid' && pay.TASP_IsPaid == true ) {
      return (
        pay.TASP_IsPaid == false
      )
    }
    else {
      return (
        (pay.userName && pay.userName.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (pay.mobileNumber && pay.mobileNumber.includes(searchQuery)) ||
        (pay.email && pay.email.toLowerCase().includes(searchQuery.toLowerCase()))
      );
    }
  });



  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };



  useEffect(() => {
    const fetchPayments = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetchAllServicePayments();
     
        const paidPayments = (res.data || []).filter(p => p);
        setPayments(paidPayments);
        console.log({paidPayments})
      } catch (err) {
        setError('Failed to fetch payment details.');
      } finally {
        setLoading(false);
      }
    };
    fetchPayments();
  }, []);


  // Handle status filter change
  const handleStatusFilterChange = (event) => {
    setStatusFilter(event.target.value);
    setPage(0); // Reset to first page on filter change
  };


  // const filterPays = (calls) => {
  //   let filtered = calls;

  //   // Apply status filter first
  //   if (statusFilter !== 'all') {
  //     filtered = filtered.filter(call => call.status === statusFilter);
  //   }

  //   // Then apply search term filter
  //   if (searchTerm) {
  //     filtered = filtered.filter(call =>
  //       (call.patient && call.patient.toLowerCase().includes(searchTerm)) ||
  //       (call.phone && call.phone.includes(searchTerm)) ||
  //       (call.receiverNumber && call.receiverNumber.includes(searchTerm)) ||
  //       (call.service && call.service.toLowerCase().includes(searchTerm)) ||
  //       (call.status && call.status.toLowerCase().includes(searchTerm))
  //     );
  //   }

  //   return filtered;
  // };

  return (
    <Box sx={{  background: theme.palette.background.default }}>
      <Paper elevation={0} sx={{
        p: { xs: 2, sm: 3 },
        mb: 2,
        borderRadius: 3,
        background: theme.palette.mode == 'dark' ? '#32373a' :  'white',
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: { xs: 'stretch', md: 'center' },
        gap: 2,
        justifyContent: 'space-between',
      }}>
        {
          isSmallScreen ? (
            <Typography variant="h6" sx={{ fontWeight: 700, flex: 1, textTransform: 'capitalize', color: 'background.text',  }}>Payment Report</Typography>
          ) : (
            <Typography variant="h4" sx={{ fontWeight: 700, flex: 1, textTransform: 'capitalize', color: 'background.text',  }}>Payment Report</Typography>
          )
        }
        {/* <Typography variant="h6" sx={{ fontWeight: 700, flex: 1, textTransform: 'uppercase', color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary, mb: { xs: 2, md: 0 } }}>Payment Report</Typography> */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2,flexDirection: { xs: 'column', sm: 'row' } }}>
          <SearchInput value={searchQuery} onChange={e => {   setSearchQuery(e.target.value);   setPage(0); }} />

            {/* Status Filter */}
          
          <FormControl size="small" sx={{minWidth: { xs: '100%', sm: 240 }, }}>
            <SelectInput
              label="Status"
              value={statusFilter}
              onChange={handleStatusFilterChange}
              options={[
                { label: 'All', value: 'all' },
                { label: 'Paid', value: 'paid' },
                { label: 'Unpaid', value: 'unpaid' },
              ]}
            />
          </FormControl>

        </Box>
      </Paper>
      
      {
        isSmallScreen ? (
          <>
          {/* Card view for small screens */}
          {loading ? (
            <Box sx={{ p: 4, textAlign: 'center' }}>
              <Typography>Loading Payment Details...</Typography>
            </Box>
          ) : error ? (
            <Box sx={{ p: 4, textAlign: 'center', color: 'red' }}>
              <Typography>{error}</Typography>
            </Box>
          ) : (
            <>
              {payments.length === 0 ? (
                <Box sx={{ p: 4, textAlign: 'center' }}>
                  <Typography sx={{color:'background.text'}}>No payment records found.</Typography>
                </Box>
              ) : (
                payments.map((payment, idx) => (
                  <Paper
                    key={payment._id || idx}
                    elevation={2}
                    sx={{
                      mb: 2,
                      borderRadius: 3,
                      p: 2,
                      position: 'relative',
                      background: theme.palette.background.paper,
                      boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                    }}
                  >
                    
                    {/* SL No. at the top */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'end',
                        mb: 1,
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          color: '#b0b0b0',
                          fontSize: '1.1rem',
                          letterSpacing: 1,
                        }}
                      >
                        # {page * rowsPerPage + idx + 1}
                      </Typography>
                    </Box>
                    <Grid container spacing={1}>
                      <Grid item xs={5}>
                        <Typography sx={{ fontWeight: 600, color:'background.text', fontSize: 14 }}>Name</Typography>
                      </Grid>
                      <Grid item xs={7}>
                        <Typography sx={{ fontWeight: 500, color:'background.text', fontSize: 15 }}>{payment.userName || '-'}</Typography>
                      </Grid>

                      <Grid item xs={5}>
                        <Typography sx={{ fontWeight: 600, color:'background.text', fontSize: 14 }}>Type From</Typography>
                      </Grid>
                      <Grid item xs={7}>
                        <Typography sx={{ fontWeight: 500, color:'background.text', fontSize: 15 }}>
                          {payment.TASP_Payment_Type === 1 ? 'Service' : 'Patient' || '-'}
                        </Typography>
                      </Grid>

                      <Grid item xs={5}>
                        <Typography sx={{ fontWeight: 600, color:'background.text', fontSize: 14 }}>Phone Number</Typography>
                      </Grid>
                      <Grid item xs={7}>
                        <Typography sx={{ fontWeight: 500, color:'background.text', fontSize: 15 }}>{payment.mobileNumber || '-'}</Typography>
                      </Grid>

                      <Grid item xs={5}>
                        <Typography sx={{ fontWeight: 600, color:'background.text', fontSize: 14 }}>Amount</Typography>
                      </Grid>
                      <Grid item xs={7}>
                        <Typography sx={{ fontWeight: 500, color:'background.text', fontSize: 15 }}><CurrencyRupeeIcon fontSize='6px' />{payment.TASP_Amount || '0'}/-</Typography>
                      </Grid>

                      <Grid item xs={5}>
                        <Typography sx={{ fontWeight: 600, color:'background.text', fontSize: 14 }}>Date</Typography>
                      </Grid>
                      <Grid item xs={7}>
                        <Typography sx={{ fontWeight: 500, color:'background.text', fontSize: 15 }}>
                          {payment.TASP_Created_At ? new Date(payment.TASP_Created_At).toLocaleString() : '-'}
                        </Typography>
                      </Grid>

                      <Grid item xs={5}>
                        <Typography sx={{ fontWeight: 600, color:'background.text', fontSize: 14 }}>Status</Typography>
                      </Grid>
                      <Grid item xs={7}>
                        <Box
                          sx={{
                            display: 'inline-block',
                            px: 2,
                            py: 0.5,
                            borderRadius: '16px',
                            fontWeight: 700,
                            fontSize: '0.95rem',
                            color: payment.TASP_IsPaid ? '#fff' : '#fff',
                            backgroundColor: payment.TASP_IsPaid
                              ? theme.palette.success.main
                              : theme.palette.error.main,
                            minWidth: 70,
                            textAlign: 'center',
                            letterSpacing: 1,
                            textTransform: 'capitalize',
                          }}
                        >
                          {payment.TASP_IsPaid ? 'Paid' : 'Unpaid'}
                        </Box>
                        {/* <Typography sx={{ fontWeight: 500, color: payment.TASP_IsPaid ? theme.palette.success.main : theme.palette.error.main, fontSize: 15 }}>
                          {payment.TASP_IsPaid ? 'Paid' : 'Unpaid'}
                        </Typography> */}
                      </Grid>

                      <Grid item xs={5}>
                        <Typography sx={{ fontWeight: 600, color:'background.text', fontSize: 14 }}>PRO</Typography>
                      </Grid>
                      <Grid item xs={7}>
                        <Typography sx={{ fontWeight: 500, color:'background.text', fontSize: 15 }}>
                          {payment.proName || '-'}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Paper>
                ))
              )}
              {/* Pagination for cards */}
              {/* <Box sx={{ px: 0, py: 1, background: theme.palette.background.default, borderRadius: 2 }}>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={filteredPays.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  labelRowsPerPage="Rows per page:"
                  labelDisplayedRows={({ from, to, count }) => `${from}–${to} of ${count}`}
                  sx={{ border: 0, background: 'transparent', p: 0, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary }}
                />
              </Box> */}
            </>
          )}
          </>
        ) : (
          <Paper elevation={1} sx={{
            borderRadius: 3,
            boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
            p: 0,
            overflow: 'auto',
            background: theme.palette.background.paper,
            mb: 3,
          }}>
            {loading ? (
              <Box sx={{ p: 4, textAlign: 'center' }}><Typography>Loading Payment Details...</Typography></Box>
            ) : error ? (
              <Box sx={{ p: 4, textAlign: 'center', color: 'red' }}><Typography>{error}</Typography></Box>
            ) : (
              <TableContainer sx={{ maxHeight: 540 }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }}>SL No.</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }}>Name</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }}>Type From</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }}>Phone Number</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }}>Amount</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }}>Date</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }}>Status</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }}>PRO</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedPays.map((payment, idx) => (
                      <TableRow key={payment._id || idx}>
                        <TableCell sx={{color: theme.palette.mode === 'dark' ? '#fff' : 'black'}}>{page * rowsPerPage + idx + 1}</TableCell>
                        <TableCell sx={{color: theme.palette.mode === 'dark' ? '#fff' : 'black'}}>{payment.userName || '-'}</TableCell>
                        <TableCell sx={{color: theme.palette.mode === 'dark' ? '#fff' : 'black'}}>{payment.TASP_Payment_Type === 1 ? 'Service' : 'Patient' || '-'}</TableCell>
                        <TableCell sx={{color: theme.palette.mode === 'dark' ? '#fff' : 'black'}}>{payment.mobileNumber || '-'}</TableCell>
                        <TableCell sx={{color: theme.palette.mode === 'dark' ? '#fff' : 'black'}}><CurrencyRupeeIcon fontSize='3px'/>{payment.TASP_Amount || ''}/-</TableCell>
                        <TableCell sx={{color: theme.palette.mode === 'dark' ? '#fff' : 'black'}}>{payment.TASP_Created_At ? new Date(payment.TASP_Created_At).toLocaleString() : '-'}</TableCell>
                        <TableCell sx={{color: theme.palette.mode === 'dark' ? '#fff' : 'black'}}>
                          <PillComponent status={payment.TASP_IsPaid ? 'paid' : 'unpaid'} />
                        </TableCell>
                        <TableCell sx={{color: theme.palette.mode === 'dark' ? '#fff' : 'black'}}>{payment.proName||'-'}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
            <Box sx={{ px: 2, py: 1, background: theme.palette.mode === 'dark' ? 'transparent':'#fff', borderRadius: '0 0 16px 16px' }}>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredPays.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage="Rows per page:"
                labelDisplayedRows={({ from, to, count }) => `${from}–${to} of ${count}`}
                sx={{ border: 0, background: theme.palette.mode === 'dark' ? 'transparent':'#fff', p: 0, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary }}
              />
            </Box>
          </Paper>
        )
      }
      {/* <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} elevation={6} variant="filled" sx={{ fontSize: 16, fontWeight: 600, borderRadius: 2 }}>
          {snackbar.message}
        </Alert>
      </Snackbar> */}
    </Box>
  );
}

export default PaymentReportPage; 